import React from 'react'
import Link from 'gatsby-link'
import styled from "styled-components";

const SiteFooter = styled('footer')`
  text-align: center;
  padding: 4rem 2rem;
  background: #333;
  color: #eee;
  a {
    color: #eee;
  }
`
const Footer = ({ siteTitle }) => (
  <SiteFooter>
    <a href="mailto:" className="link b f3 f2-ns dim black-70 lh-solid">hello@unlo.st</a>
    <p className="f6 db b ttu lh-solid">©2018 unlo.st</p>
    <div className="mt5">
      <a href="/terms/"    title="Terms" className="">Terms of Use</a>
    </div>
  </SiteFooter>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js